export enum YesOrNoType {
    yes = '1',
    no = '0',
}
